import Model from "@/app/models/Concerns/Model";
import StorageAttachment from "@/app/support/StorageAttachment";

export default class Station extends Model {
    division_id!: number|null;
    template_date!: string;
    work_instruction_name!: string|null;
    work_instruction_url?: string|null;
    work_instructions?: File|null;
    attachments!: Array<StorageAttachment|File>;
    dashboard_info?: string|null;
    is_scaffoldless_station?: boolean;

    get casts(): any {
        return {
            attachments: (data: any[]) => data.map((attachment: any) => new StorageAttachment(attachment)),
        };
    }

    getTable(): string {
        return "stations";
    }

    protected asFormData(): FormData {
        let formData = new FormData();

        Object.entries(this)
            .forEach(([key, value]) => {
                if (key === 'attachments') {
                    // For attachments, we only want to send the files, not the StorageAttachment objects
                    value = value.filter((attachment: StorageAttachment|File) => attachment instanceof File);
                }

                this.appendToFormData(formData, key, value);
            });

        return formData;
    }

    public async save(): Promise<Model> {
        let data: FormData = this.asFormData();

        // @ts-ignore
        await this.constructor[
            this.id == null
                ? "store"
                : "update"
            ](data, this.id).then(
            (model: Model) => {
                this.setProperties(model);
            }
        );
        return this;
    }
}